export default {
      id: "question-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#question-usage",
      toString: function () {
        return this.url;
      }
    }